
export const setNaturals = (state, naturals) => {
    state.naturals = naturals
    state.loading = false
}


export const setCurrentNatural = (state, natural) => {
    state.currentNatural = natural
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
